import { Add, Search } from '@mui/icons-material'
import { Box, Divider, CircularProgress, Typography, Link, Icon, Skeleton } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import AdxSortTable from 'components/reusable/table/AdxSortTable'
import React, { useEffect, useState } from 'react'
import PayrunHeader from '../components/Header'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'
import AdjustedCardList from '../components/AdjustedCardList'
import EmployeeList from 'module/payroll/global-components/EmployeeList'
import { useQuery } from 'react-query'
import { retrieveEmployeeData } from 'services/api/modules/payroll/payroll-view'
import EmpSalaryDetails from '../components/EmpSalaryDetails'
import AdxButton from 'components/custom/AdxButton'
import ClaimBadge from '../components/ClaimBadge'
const RegularPayroll = ({ items }) => {
  let timeIdProps = { time_id: items }
  const {
    data: retrieveData,
    isLoading: loadingData,
    refetch: refetchEmployeeData,
  } = useQuery(['retrieveEmployeeData', items], () => retrieveEmployeeData(items))
  const [sortedDetails, setSortedDetails] = useState([])
  const [timeId, setTimeId] = useState()
  const [currentState, setCurrentState] = useState([])
  const [filteredDetails, setFilterDetails] = useState([])
  const [adjustedEmployee, setAdjustedState] = useState([])
  const [keywords, setKeywords] = useState('')
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    refetchEmployeeData()
  }, [location.key, refetchEmployeeData])

  useEffect(() => {
    if (retrieveData) {
      setSortedDetails(retrieveData?.data)
      setTimeId(retrieveData)
    }
  }, [retrieveData])
  useEffect(() => {
    let initialState = sortedDetails?.filter((list) => {
      if (list.status === 0) {
        return list
      } else {
        return null
      }
    })
    setCurrentState(initialState)
  }, [sortedDetails])

  useEffect(() => {
    let adjustedState = sortedDetails?.filter((list) => {
      if (list.status === 1) {
        return list
      } else {
        return null
      }
    })
    setAdjustedState(adjustedState)
  }, [sortedDetails])

  useEffect(() => {
    let arr = currentState?.filter((val) => {
      if (keywords === '') {
        return val
      } else if (val.name.toLowerCase().includes(keywords.toLowerCase())) {
        return val
      } else {
        return null
      }
    })
    setFilterDetails(arr)
  }, [keywords, currentState])

  // approved claims per employee (only when Claims is connected to payroll)
  const claimSummary = retrieveData?.claims_in_payroll ? retrieveData?.claim_summary : null

  const columnHeader = [
    {
      Header: (props) => {
        const { column } = props
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
            }}
          >
            <Typography variant="subtitle2">Employee</Typography>
            {column.isSorted ? (
              column.isSortedDesc ? (
                <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_up</Icon>
              ) : (
                <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_down</Icon>
              )
            ) : (
              <Icon
                sx={{
                  fontSize: '32px',
                  color: 'gray-inactive-button.main',
                }}
              >
                arrow_drop_down
              </Icon>
            )}
          </Box>
        )
      },
      accessor: 'name',
      Cell: (props) => {
        const { cell } = props
        return (
          <Box>
            <EmployeeList
              avatar={cell.row.original.avatar}
              sxContent={{ maxWidth: '300px' }}
              sx={{ minWidth: '350px' }}
              name={cell.row.original.name}
              position={cell.row.original.position}
            />
            <ClaimBadge summary={claimSummary?.[cell.row.original.id]} sx={{ pl: 7 }} />
          </Box>
        )
      },
    },
    {
      Header: 'Type',
      accessor: 'salary.type',
      disableSortBy: true,
    },
    {
      Header: (props) => {
        const { column } = props
        return (
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle2"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              Net pay (RM)
            </Typography>
            {column.isSorted ? (
              column.isSortedDesc ? (
                <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_up</Icon>
              ) : (
                <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_down</Icon>
              )
            ) : (
              <Icon
                sx={{
                  fontSize: '32px',
                  color: 'gray-inactive-button.main',
                }}
              >
                arrow_drop_down
              </Icon>
            )}
          </Box>
        )
      },
      accessor: 'salary.nett',
      sortType: (prev, curr) => {
        if (
          parseFloat(prev?.original?.salary?.nett?.replace(/,/g, '')) >
          parseFloat(curr?.original?.salary?.nett?.replace(/,/g, ''))
        ) {
          return 1
        } else if (
          parseFloat(prev?.original?.salary?.nett?.replace(/,/g, '')) <
          parseFloat(curr?.original?.salary?.nett?.replace(/,/g, ''))
        ) {
          return -1
        } else {
          return 0
        }
      },
    },
  ]
  const [drawerState, setDrawerState] = useState({ right: false })
  const [employeeDrawer, setEmployeeDrawer] = useState({})
  const [employeeDetail, setEmployeeDetail] = useState({})
  useEffect(() => {
    setEmployeeDetail(sortedDetails?.find((tre) => tre.id === employeeDrawer.id))
  }, [employeeDrawer, sortedDetails])
  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
  }
  const viewDetails = (details) => {
    setDrawerState({ ...drawerState, right: true })
    setEmployeeDrawer(details)
  }
  const handleNext = () => {
    navigate(`/app/payroll/regular-payroll/${timeId.month}-${timeId.year}/summary`, {
      state: items,
    })
  }
  return (
    <Box bgcolor="gray-background.main">
      <PayrunHeader
        nextButton="Next"
        handleNext={handleNext}
        payrollPeriod={timeId}
        loadingData={loadingData}
      />
      <Divider sx={{ color: 'gray-line.main' }} />
      <Box sx={{ display: 'flex', gap: 2, p: 3 }}>
        <Box sx={{ width: 2 / 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 600 }}>
                Employee
              </Typography>
              <AdxInput
                type="standard"
                onChange={(e) => setKeywords(e.target.value)}
                startAdornment={<Search color="light-gray-text" sx={{ mr: 1 }} />}
                placeholder="Search employee name"
                sx={{
                  width: 'auto',
                  '& .MuiInputBase-root': {
                    minHeight: '45px',
                    width: '500px',
                    outlineColor: '#E5E5E5',
                    bgcolor: 'white.main',
                  },
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              bgcolor: 'white.main',
              border: 1,
              borderColor: 'gray-line.main',
              borderRadius: '4.5px',
              overflow: 'clip',
            }}
          >
            {loadingData ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  backgroundColor: 'white.main',
                  borderRadius: 2,
                  height: 'calc(100vh - 185px)',
                }}
              >
                <CircularProgress color="alternate" size={60} />
              </Box>
            ) : (
              <>
                <AdxSortTable
                  column={columnHeader}
                  data={filteredDetails}
                  nav="View"
                  sx={{ height: 'calc(100vh - 200px)', boxShadow: 'none' }}
                  onClick={viewDetails}
                  stickyHeader="stickyHeader"
                  sxNav={{ textDecoration: 'underline' }}
                  allColumnSorted={false}
                />
                <EmpSalaryDetails
                  drawerState={drawerState}
                  handleDrawer={handleDrawer}
                  details={employeeDetail}
                  time_id={items}
                />
              </>
            )}
          </Box>
        </Box>
        <Box sx={{ width: 1 / 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography
              variant="h4"
              sx={{ fontWeight: 600 }}
            >{`Adjusted employee (${adjustedEmployee?.length})`}</Typography>
            <Link
              component={RouterLink}
              to="/app/payroll/regular-payroll/edit"
              state={timeIdProps}
              underline="none"
            >
              <AdxButton variant={'outlined'} startIcon={<Add />}>
                Add
              </AdxButton>
            </Link>
          </Box>
          <Box
            sx={{
              display: 'flex',
              bgcolor: 'white.main',
              border: 1,
              borderColor: 'gray-line.main',
              borderRadius: '4.5px',
              height: 'calc(100vh - 200px)',
              overflowY: 'auto',
            }}
          >
            {loadingData ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', p: 2 }}>
                <Skeleton width={250} />
                <Skeleton width={300} />
                <Skeleton width={200} />
              </Box>
            ) : adjustedEmployee?.length !== 0 ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', p: 2 }}>
                {adjustedEmployee?.map((item) => (
                  <AdjustedCardList
                    data={item}
                    time_id={items}
                    onView={viewDetails}
                    claimSummary={claimSummary?.[item.id]}
                  />
                ))}
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  p: 2,
                  placeSelf: 'center',
                }}
              >
                <Typography textAlign="center" color="light-gray-text.main" sx={{ mb: 2 }}>
                  You don't have any adjusted employee for this run. Click button below to add
                  employees that have special updates
                </Typography>
                <Link
                  component={RouterLink}
                  to="/app/payroll/regular-payroll/edit"
                  state={timeIdProps}
                  underline="none"
                >
                  <AdxButton variant={'outlined'} startIcon={<Add />}>
                    Add
                  </AdxButton>
                </Link>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default RegularPayroll
